export default "__VITE_ASSET__Bx$$ZCrM__"